export const AGE_GROUPS = [
  {
    value: 'group1',
    label: '15 days - 9 years old'
  },
  {
    value: 'group2',
    label: '10-39 years old'
  },
  {
    value: 'group3',
    label: '40-49 years old'
  },
  {
    value: 'group4',
    label: '50-59 years old'
  },
  {
    value: 'group5',
    label: '60-69 years old'
  }
];

export const WORLD_TRIPS_AGE_GROUPS = [
  {
    value: 'group1',
    label: '15 days - 9 years old'
  },
  {
    value: 'group2',
    label: '10-39 years old'
  },
  {
    value: 'group3',
    label: '40-49 years old'
  },
  {
    value: 'group4',
    label: '50-59 years old'
  },
  {
    value: 'group5',
    label: '60-64 years old'
  },
  {
    value: 'group6',
    label: '65-69 years old'
  }
];
